import Type from './../types'

export default {
    state:{
        
    },
    mutations: {
        
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/search.js